import React from 'react';
import ReactSelect, {
  OptionTypeBase,
  ValueType,
  Props as SelectProps,
  components
} from 'react-select';
import StyledDropdownSelect from './Styled';
import { OptionWithBadge } from './OptionWithBadge';

export interface DropdownSelectProps extends SelectProps<OptionTypeBase> {
  onSelect?: (value: OptionTypeBase) => void;
}

const CustomOption = (props: any) => {
  return (
    <components.Option {...props}>
      <OptionWithBadge isNewFeature={props.data.isNewFeature}>
        {props.children}
      </OptionWithBadge>
    </components.Option>
  );
};

const DropdownSelect: React.FC<DropdownSelectProps> = props => {
  const { options, onSelect, ...otherProps } = props;

  const onChange = (value: ValueType<OptionTypeBase, false>) => {
    onSelect && onSelect(value as OptionTypeBase);
  };

  return (
    <StyledDropdownSelect>
      <ReactSelect
        {...otherProps}
        onChange={onChange}
        options={options}
        className="dropdown-filter-container"
        classNamePrefix="dropdown-filter-content"
        components={{ Option: CustomOption }}
      />
    </StyledDropdownSelect>
  );
};

export default DropdownSelect;
